export default __webpack_public_path__ + "static/media/katana right.ef96c6dc.png";